import React from 'react';
import './appSync.scss';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function AppSync() {
    return (
        <div className="app-sync">
            Syncing
            <Spin indicator={<LoadingOutlined spin />} size="small" />
        </div>
    );
}

export default AppSync;